<template>
  <div>
    <div class="modal__confirm__delete-wrapper text-dark"
         :class="[{'js-no-close': appendToBody}, {'modal__confirm__delete__wider': isShowDontAskAgain}]"
         ref="d_modal"
         @click.self="$emit('close')">
      <div class="modal__confirm__delete">
        <div class="close-cross icon__bg-circle" v-if="showClose" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
        <slot name="insertComponent">
          <div class="modal__confirm__delete__template" slot="insertComponent">
            <div>
              <div class="modal__confirm__delete__close icon__bg-circle" @click.stop="$emit('close')">
                <span class="icon-cross2"></span>
              </div>
              <slot name="item"></slot>
              <template v-if="isShowConfirmDeleteMessage">
                <h4 v-if="!isOnlyOwnCalendarText">{{ i18n.are_you_sure }}</h4>
                <h4 v-if="isOnlyOwnCalendarText">{{ i18n.are_you_sure_own_calendar }}</h4>
              </template>
              <div>
                <slot name="custom_warning"></slot>
              </div>
              <div class="modal__confirm__delete__buttons">
                <div class="do-checkbox-group" v-if="isShowDontAskAgain">
                  <input type="checkbox" v-model="isDontAskAgain" id="dontAskAgain" class="form-check-input">
                  <label for="dontAskAgain" class="d-label form-check-label">{{ i18n.dont_ask_me_again }}</label>
                </div>
                <div class="modal__confirm__delete__buttons__buttons">
                  <slot name="confirm_buttons">
                    <button @click.stop="$emit('close')">{{ i18n.cancel }}</button>
                    <button class="bttn bttn--danger"
                            :class="{'bttn--loading': isSubmitButtonLoading}"
                            ref="submit_bttn"
                            @keyup.enter="onConfirm "
                            @keyup.esc="$emit('close')"
                            @click.stop="onConfirm">
                      <slot name="confirmText">{{ i18n.delete }}</slot>
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
const I18N = {
  da: {
    are_you_sure: 'Er du sikker på, at du vil slette denne?',
    are_you_sure_own_calendar: 'Er du sikker på, at du vil slette denne brik? Det vil kun gælde for denne kalender og kan ikke fortrydes. Venligst bekræft, hvis du ønsker at fortsætte.',
    delete: 'Slet',
    cancel: 'Annuller',
    dont_ask_me_again: 'Spørg mig ikke igen'
  },
  nb: {
    are_you_sure: 'Er du sikker på at du vil slette dette?',
    are_you_sure_own_calendar: 'Er du sikker på at du vil slette dette? Dette vil kun gjelde for denne kalenderen og kan ikke reverseres. Vennligst bekreft at du ønsker å fortsette.',
    delete: 'Slett',
    cancel: 'Annuller',
    dont_ask_me_again: 'Ikke spør meg igjen'
  },
  en: {
    are_you_sure: 'Are you sure that you want to delete this?',
    are_you_sure_own_calendar: 'Are you sure you want to delete this? This will only apply to this calendar and cannot be undone. Please confirm if you wish to proceed.',
    delete: 'Delete',
    cancel: 'Cancel',
    dont_ask_me_again: 'Don\'t ask me again'
  }
}

export default {
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    isOnlyOwnCalendarText: {
      type: Boolean,
      default: false
    },
    isSubmitButtonLoading: {
      type: Boolean,
      default: false
    },
    isShowDontAskAgain: {
      type: Boolean,
      default: false
    },
    propLocale: {
      default: null
    },
    isShowConfirmDeleteMessage: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isDontAskAgain: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return !this.propLocale ? I18N[this.locale] : I18N[this.propLocale]
    }
  },
  methods: {
    onConfirm () {
      this.$emit('confirm', this.isDontAskAgain)
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = this.$refs.submit_bttn
      if (el) {
        this.$refs.submit_bttn.focus()
      }
    })
    if (this.appendToBody) {
      const el = this.$refs.d_modal
      const bod = document.getElementById('djs-content-container')
      if (bod) {
        bod.appendChild(el)
      }
    }
  },
  beforeDestroy () {
    const el = this.$refs.d_modal
    if (el) {
      el.remove()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.modal__confirm__delete-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1212121212;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__confirm__delete {
  position: relative;
  z-index: 9999;
  background: #f6f9fc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  animation-name: fadeUp;
  animation-duration: 0.25s;
}

.modal__confirm__delete__close {
  cursor: pointer;
  color: #ffffff;
}

.close-cross {
  position: absolute;
  color: #ffffff;
  top: -1.5rem;
  right: 0rem;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
}

.modal__confirm__delete {
  position: relative;
  display: flex;
  flex-direction: column;
}

.modal__confirm__delete__close {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  color: var(--grey);
  transition: 0.25s;
}

.modal__confirm__delete__close:hover {
  color: var(--dark-blue);
}

.modal__confirm__delete h4 {
  margin: 0;
  padding: 2rem 1rem;
}

.modal__confirm__delete__buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
}

.modal__confirm__delete__wider .modal__confirm__delete__buttons {
  justify-content: space-between;
}

.modal__confirm__delete__buttons button:last-child {
  margin-left: 0.5rem;
}

.modal__confirm__delete__template {
  width: 350px;
}

.modal__confirm__delete__wider .modal__confirm__delete__template {
  width: 400px;
}

.bttn--danger {
  color: var(--danger);
  background-color: #ffffff;
}

.d-modal--from-top {
  align-items: flex-start;
  padding-top: 150px;
}

.modal__confirm__delete__buttons {
  padding: 1rem;
  background-color: #ffffff;
  border-top: 1px solid var(--ligthGrey);
}

.do-checkbox-group {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  gap: 0.5rem;
  cursor: pointer;
}

.do-checkbox-group label {
  cursor: pointer;
  text-transform: initial;
}

.modal__confirm__delete__buttons__buttons {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// ModalConfirmation.vue?a617e41c